export const XM_SITE_PENDING_APPLY_TPL_CODE = 'hx_site_pending_apply_template_code'
export const XM_SITE_PENDING_APPLY_TPL_UNSUPPORTED_BANNER = 'hx_site_pending_apply_template_unsupported_banner'
export const XM_SITE_PENDING_PRODUCT_CODE = 'hx_site_pending_product_code'
